class exports.FormHelper
    constructor: (formselector = null, dataObj = {}) ->
        if formselector?
            @setForm formselector

        @setData dataObj

    setForm: (formselector) ->
        if not (formselector instanceof jQuery)
            @form = $(formselector)
        else
            @form = formselector

    setData: (dataObj) ->
        options =
            requireObjectRenderers: false
            requireArrayRenderers: true

        if dataObj.options?
            options = $.extend true, options, dataObj.options

        dataObj.options = options

        dataObj.renderers ?= {}
        dataObj.data ?= {}
        @data = dataObj


    getData: () ->
        return @data.data


    fill: () ->
        @_iterateAndRenderData @form, @data.data


    guessSelector: (selector, key) ->
        return selector.find('[data-prefill-name="' + key + '"],[name="' + key + '"]')


    callRenderer: (rendername, elem, val, ind = null) ->
        result = @data.renderers[rendername](elem, val, ind)
        d = {}
        d.element = result.element ? null

        d.value = result.value ? val
        if d.element?
            d.element.data('data_object', d.value)
        return d


    remove: (selector) ->
        if selector.data('data_object')?
            #console.log selector.data()
            if selector.data('parent_data_object')?
                #console.log 'parenty!'
                parento = selector.data('parent_data_object')
                indx = parento.indexOf selector.data('data_object')
                parento.splice indx, 1

            ###
            object = selector.data('data_object')
            #console.log 'object:'
            #console.log object
            object = null
            selector.data('data_object',null)
            #selector.data('data_object') = null
            delete selector.data('data_object')
            ###

        selector.remove()
    ###
    renderNew
        Is used to call the renderer specified by `rendername`, and create a new data object from the rendered
        inputs.
        This is probably really only useful for rendering things like layer planting stages, where your
        renderer is actually generating elements

        Params:
            rendername      - renderer to call
            elem            - selector to pass into the renderer
            copy            - if true, values will be copied into the new object from the renderer's returned element

        Return:
            {
                element     - selector pointing at newly rendered element
                value       - the newly generated data object, representing the inputs that exist in the rendered element
            }
    ###
    renderNew: (rendername, elem, copy = false) ->
        r = @callRenderer rendername, elem
        split = rendername.split('.')

        obj = @_reverseEngineerObject r.element, copy

        ### MAGIC ###
        if elem.data('data_object')?
            d = elem.data('data_object')
            d[split[split.length - 1]].push obj
            r.element.data('parent_data_object', d[split[split.length - 1]])
        else
            p = @data.data
            for i in split
                if not p[i]?
                    # This... may not be smart.
                    if i < split.length - 1
                        p[i] = {}
                    else
                        p[i] = []

                p = p[i]

            p.push obj
            r.element.data('parent_data_object', p)


        r.element.data('data_object', obj)

        @_iterateAndRenderData r.element, obj, rendername
        return {
            element: r.element
            value: obj
        }


    _reverseEngineerObject: (selector, copy = false) ->
        obj = {}
        selector.find('input, select').each () ->
            name = $(this).data('prefill-name') ? $(this).attr('name')
            if copy
                obj[name] = $(this).val()
            else
                obj[name]  = null

        return obj


    _attachChangeListener: (selector, data, key) ->
        selector.change () ->
            data[key] = $(this).val()


    _iterateAndRenderData: (element, data, prefix = null) ->
        for k, v of data
            if prefix?
                rendername = "#{prefix}.#{k}"
            else
                rendername = "#{k}"

            renderer = @data.renderers[rendername]
            if $.isArray v
                for i, ind in v
                    if renderer?
                        r = @callRenderer rendername, element, i, ind
                        elem = r.element ?
                        i = r.value
                    else if @data.options.requireArrayRenderers
                        break
                    else
                        elem = element
                    #console.log 'setting parent for #{rendername}'
                    #console.log v
                    elem.data('parent_data_object', v)
                    @_iterateAndRenderData elem, i, rendername

            else if (v is Object(v))
                if renderer?
                    r = @callRenderer rendername, element, v, k
                    elem = r.element
                    v = r.value
                else if @data.options.requireObjectRenderers
                    continue
                else
                    elem = element

                @_iterateAndRenderData elem, v, rendername
            else
                elem = @guessSelector element, k
                if renderer?
                    r = @callRenderer rendername, element, v, k
                    elem = r.element ? elem

                    v = r.value


                @_attachChangeListener elem, data, k
                elem.val(v)
